import React from 'react'

import { Row, Col } from '_zari/core'

import * as CompaniaService from 'services/compania.service'

import * as InnerCells from './cells'

const AccesosSeriesTab = ({ companiasSeleccionadas, sedesSeleccionadas, seriesSeleccionadas }) => {
  const [companiasListadas, setCompaniasListadas] = React.useState([])

  React.useEffect(() => {
    CompaniaService.obtenerTodoMasSedesMasSeries().then(({ data }) => {
      setCompaniasListadas(data)
    })
  }, [])

  return (
    <Row>
      <Col md={12}>
        <table border='1' width='100%'>
          <thead>
            <tr>
              <th align='center'>COMPANIA</th>
              <th align='center'>ESTABLECIMIENTO</th>
              <th align='center'>SERIE</th>
            </tr>
          </thead>
          <tbody>
            {companiasListadas.map(x => (
              <React.Fragment key={x._id}>
                {x.sedes.map((y, k) => (
                  <tr key={y._id}>
                    {k === 0 ? (
                      <>
                        <td rowSpan={x.sedes.length} valign='top'>
                          <InnerCells.CompaniaCell cellInfo={x} checked={companiasSeleccionadas.some(z => z === x._id)} />
                        </td>
                        <td valign='top'>
                          <InnerCells.SedeCell cellInfo={y} checked={sedesSeleccionadas.some(z => z === y._id)} />
                        </td>
                        <td>
                          {y.series.map((w, j) => (
                            <InnerCells.SerieCell key={w._id} cellInfo={w} checked={seriesSeleccionadas.some(z => z === w._id)} />
                          ))}
                        </td>
                      </>
                    ) : (
                      <>
                        <td valign='top'>
                          <InnerCells.SedeCell cellInfo={y} checked={sedesSeleccionadas.some(z => z === y._id)} />
                        </td>
                        <td>
                          {y.series.map((w, j) => (
                            <InnerCells.SerieCell key={w._id} cellInfo={w} checked={seriesSeleccionadas.some(z => z === w._id)} />
                          ))}
                        </td>
                      </>
                    )}
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </Col>
    </Row>
  )
}

export default React.memo(AccesosSeriesTab)
